var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-main",
    { attrs: { app: "" } },
    [
      _c(
        "v-container",
        {
          staticClass: "horizontal-container rounded-lg relative",
          class: { "grey lighten-5": !_vm.$vuetify.theme.dark },
          staticStyle: { "margin-top": "130px !important" },
        },
        [
          _c("top-nav-menu", { staticClass: "mb-4" }),
          _c(
            "v-expand-transition",
            { attrs: { mode: "out-in" } },
            [_c("router-view")],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "flex-grow-1" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }